<div class="agpr-portfolios-container">
    <div class="agpr-portfolios-leftside">
        <span class="fa-regular fa-duotone fa-eye agpr-portfolios-leftside-icon" aria-hidden="true"></span>
        <div class="agpr-portfolios-leftside-bigText">{{'Discover.portfolios.hype.header' | localize}}</div>
        <div class="agpr-portfolios-leftside-smallText">{{'Discover.portfolios.hype.details' | localize}}</div>
    </div>
    <div class="agpr-portfolios-rightside">
        <div class="agpr-portfolios-label">
            {{'Discover.portfolios.selectListType' | localize}}
        </div>
        <div class="agpr-portfolios-bigButton-container">
            <div
                class="agpr-portfolios-bigButton"
                [ngClass]="{'selected' : portfolioService.entityType === entityTypes.CONTACT}"
                (agprClickUnless)="portfolioService.entityType = entityTypes.CONTACT"
            >
                <span class="fa-regular fa-duotone fa-user agpr-portfolios-bigButton-icon" aria-hidden="true"></span>
                <div>
                    {{'Discover.universal.contacts' | localize }}
                </div>
            </div>
            <div
                class="agpr-portfolios-bigButton"
                [ngClass]="{'selected' : portfolioService.entityType === entityTypes.OUTLET}"
                (agprClickUnless)="portfolioService.entityType = entityTypes.OUTLET"
            >
                <span class="fa-kit-duotone fa-agpr-outlet agpr-portfolios-bigButton-icon" aria-hidden="true"></span>
                <div>
                    {{'Discover.universal.outlets' | localize }}
                </div>
            </div>
        </div>

        <div class="agpr-portfolios-label">
            {{'Discover.portfolios.selectListRegion' | localize}}
        </div>
        <div class="agpr-portfolios-bigButton-container">
            <div
                class="agpr-portfolios-bigButton"
                [ngClass]="{'selected' : portfolioService.region === portfolioRegions.UNITED_STATES}"
                (agprClickUnless)="portfolioService.region = portfolioRegions.UNITED_STATES"
            >
                <img [src]="appBaseHref + 'assets/images/us.png'" class="agpr-portfolios-bigButton-flag" alt="" />
                <div>
                    {{'Discover.portfolios.regions.UNITED_STATES' | localize }}
                </div>
            </div>
            <div
                class="agpr-portfolios-bigButton"
                [ngClass]="{'selected' : portfolioService.region === portfolioRegions.UNITED_KINGDOM}"
                (agprClickUnless)="portfolioService.region = portfolioRegions.UNITED_KINGDOM"
            >
                <img [src]="appBaseHref + 'assets/images/uk.png'" class="agpr-portfolios-bigButton-flag" alt="" />
                <div>
                    {{'Discover.portfolios.regions.UNITED_KINGDOM' | localize }}
                </div>
            </div>
            <div
                class="agpr-portfolios-bigButton"
                [ngClass]="{'selected' : portfolioService.region === portfolioRegions.CANADA}"
                (agprClickUnless)="portfolioService.region = portfolioRegions.CANADA"
            >
                <img [src]="appBaseHref + 'assets/images/ca.png'" class="agpr-portfolios-bigButton-flag" alt="" />
                <div>
                    {{'Discover.portfolios.regions.CANADA' | localize }}
                </div>
            </div>
            <div
                class="agpr-portfolios-bigButton"
                [ngClass]="{'selected' : portfolioService.region === portfolioRegions.FRANCE}"
                (agprClickUnless)="portfolioService.region = portfolioRegions.FRANCE"
            >
                <img [src]="appBaseHref + 'assets/images/fr.png'" class="agpr-portfolios-bigButton-flag" alt="" />
                <div>
                    {{'Discover.portfolios.regions.FRANCE' | localize }}
                </div>
            </div>
        </div>

        <div class="agpr-portfolios-label">
            {{'Discover.portfolios.selectListCategory' | localize}}
        </div>
        <div class="agpr-portfolios-bigButton-container">
            <div
                class="agpr-portfolios-bigButton"
                [ngClass]="{'selected' : portfolioService.category === portfolioCategories.NATIONAL_NEWS_MEDIA}"
                (agprClickUnless)="portfolioService.category = portfolioCategories.NATIONAL_NEWS_MEDIA"
            >
                <span class="fa-kit-duotone fa-agpr-outlet agpr-portfolios-bigButton-icon" aria-hidden="true"></span>
                <div>
                    {{'Discover.portfolios.categories.NATIONAL_NEWS_MEDIA' | localize }}
                </div>
            </div>
            <div
                class="agpr-portfolios-bigButton"
                [ngClass]="{'selected' : portfolioService.category === portfolioCategories.REGIONAL_NEWS_MEDIA}"
                (agprClickUnless)="portfolioService.category = portfolioCategories.REGIONAL_NEWS_MEDIA"
            >
                <span class="fa-kit-duotone fa-agpr-outlet agpr-portfolios-bigButton-icon" aria-hidden="true"></span>
                <div>
                    {{'Discover.portfolios.categories.REGIONAL_NEWS_MEDIA' | localize }}
                </div>
            </div>
            <div
                class="agpr-portfolios-bigButton"
                [ngClass]="{'selected' : portfolioService.category === portfolioCategories.CULTURAL_NEWS_MEDIA}"
                (agprClickUnless)="portfolioService.category = portfolioCategories.CULTURAL_NEWS_MEDIA"
            >
                <span class="fa-kit-duotone fa-agpr-outlet agpr-portfolios-bigButton-icon" aria-hidden="true"></span>
                <div>
                    {{'Discover.portfolios.categories.CULTURAL_NEWS_MEDIA' | localize }}
                </div>
            </div>
            <div
                class="agpr-portfolios-bigButton"
                [ngClass]="{'selected' : portfolioService.category === portfolioCategories.LEADING_BY_SECTOR}"
                (agprClickUnless)="portfolioService.category = portfolioCategories.LEADING_BY_SECTOR"
            >
                <span class="fa-kit-duotone fa-agpr-outlet agpr-portfolios-bigButton-icon" aria-hidden="true"></span>
                <div>
                    {{'Discover.portfolios.categories.LEADING_BY_SECTOR' | localize }}
                </div>
            </div>
        </div>
        <agpr-button
            class="agpr-portfolios-viewlist"
            label="Discover.portfolios.hype.viewLists"
            [style]="buttonTypes.primary"
            (click)="portfolioService.goToResults()"
        >
        </agpr-button>
    </div>
</div>